// components/Text.jsx
import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import Localization from "aldoo-ra/Localization"

const Text = (params) => {
  const { id, data: replacement, fallback, ...otherParams } = params
  const { t, tjsx } = Localization()

  const containsMarkup =
    replacement &&
    Object.entries(replacement).some(([key, value]) => {
      return typeof value === "object"
    })

  const replacer = containsMarkup ? tjsx : t

  // Use CMSRender with fallback handling
  return (
    <CMSRender
      contentType="Text"
      match={{ "content.id": id }}
      renderItem={(data) => {
        return (
          <Typography {...otherParams}>
            {replacer(data.text, replacement)}
          </Typography>
        )
      }}
      fallback={() => {
        // If no fallback provided, return empty Typography to maintain layout
        if (!fallback) {
          return <Typography {...otherParams}>{id || ""}</Typography>
        }

        // If fallback provided, use fallback
        return <Typography {...otherParams}>{fallback}</Typography>
      }}
    />
  )
}

export default Text
